/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_Official_PageInputs */

const en_fc_footer_official_page = /** @type {(inputs: Fc_Footer_Official_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft on ArtCraft`)
};

/**
* | output |
* | --- |
* | "FilmCraft on ArtCraft" |
*
* @param {Fc_Footer_Official_PageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_official_page = /** @type {((inputs?: Fc_Footer_Official_PageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_Official_PageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_official_page(inputs)
});
export { fc_footer_official_page as "fc.footer.official_page" }